import React from 'react';

import type { SmartContractVerificationConfig } from 'types/client/contract';

import config from 'configs/app';
import { useI18n } from 'lib/i18n/context';

import ContractVerificationMethod from '../ContractVerificationMethod';
import ContractVerificationFieldAutodetectArgs from '../fields/ContractVerificationFieldAutodetectArgs';
import ContractVerificationFieldCompiler from '../fields/ContractVerificationFieldCompiler';
import ContractVerificationFieldName from '../fields/ContractVerificationFieldName';
import ContractVerificationFieldSources from '../fields/ContractVerificationFieldSources';
import ContractVerificationFieldZkCompiler from '../fields/ContractVerificationFieldZkCompiler';
import { CONTRACT_VERIFICATION_FIELD_KEYS, CONTRACT_VERIFICATION_METHOD_TITLE_KEYS } from '../i18n';

const FILE_TYPES = [ '.json' as const ];
const rollupFeature = config.features.rollup;

const ContractVerificationStandardInput = ({ config }: { config: SmartContractVerificationConfig }) => {
  const { t } = useI18n();
  return (
    <ContractVerificationMethod
      title={ t(CONTRACT_VERIFICATION_METHOD_TITLE_KEYS['standard-input']) }
      disableScroll={ config.verification_options.length === 1 }
    >
      { !config?.is_rust_verifier_microservice_enabled && <ContractVerificationFieldName/> }
      <ContractVerificationFieldCompiler/>
      { rollupFeature.isEnabled && rollupFeature.type === 'zkSync' && <ContractVerificationFieldZkCompiler/> }
      <ContractVerificationFieldSources
        fileTypes={ FILE_TYPES }
        title={ t(CONTRACT_VERIFICATION_FIELD_KEYS.sources.standardInputJsonTitle) }
        hint={ t(CONTRACT_VERIFICATION_FIELD_KEYS.sources.standardInputJsonHint) }
        required
      />
      { !config?.is_rust_verifier_microservice_enabled && <ContractVerificationFieldAutodetectArgs/> }
    </ContractVerificationMethod>
  );
};

export default React.memo(ContractVerificationStandardInput);
